import{jsx as _jsx}from"react/jsx-runtime";import React from"react";import{ruiTWMerge}from"../helpers/ruiTWMerge.js";/**
 * Adds the default classes for this site's theme to the props.
 *
 * @template P The type of the props for the component being extended.
 * @param props The props to add the classes to.
 * @param themeClassName The theme class name to add.
 * @returns The props with the classes added.
 */export function overrideDefaultClasses(props,themeClassName){const{className:extendedClassName,...rest}=props;const className=ruiTWMerge(themeClassName,extendedClassName);return{className,...rest}}/**
 * Wraps a component with the local theme classes.
 *
 * @template C The type of the component being extended.
 * @param Component The component to wrap.
 * @param themeClassName The theme class name to add.
 * @returns The wrapped component.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function themeComponent(Component,themeClassName){return props=>{const adjustedProps=overrideDefaultClasses(props,themeClassName);return /*#__PURE__*/_jsx(Component,{...adjustedProps})}}